var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttachedFilesDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_626",
    "data-name": "Rect\\xE1ngulo 626",
    width: 44,
    height: 44,
    transform: "translate(-0.389 -0.389)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_57",
    "data-name": "Enmascarar grupo 57",
    transform: "translate(0.389 0.389)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1020",
    "data-name": "Trazado 1020",
    d: "M11.17,0h1.437c.045.017.088.037.134.05a3.928,3.928,0,0,1,3.076,3.476c.049.354.215.413.523.412,3.772-.007,7.544,0,11.315-.01a1.228,1.228,0,0,1,1.267.747V32.146a1.251,1.251,0,0,1-1.279.741c-.958-.013-1.916.007-2.874-.008-.328-.005-.447.111-.439.438.016.695.015,1.39,0,2.085a1.074,1.074,0,0,1-1.091,1.172c-.214.02-.43.024-.646.024q-6.682,0-13.364,0c-.215,0-.43-.017-.646-.022a1.218,1.218,0,0,1-.857-.395Q4.06,32.5.388,28.832A1.255,1.255,0,0,1,0,27.9Q.005,18.555,0,9.209A1.142,1.142,0,0,1,.209,8.5,1.241,1.241,0,0,1,1.3,8.058c.922-.006,1.844,0,2.766,0,.535,0,.551-.017.552-.539,0-.8-.011-1.606.007-2.408a1.086,1.086,0,0,1,1.2-1.173c.551-.006,1.1-.013,1.652,0,.292.009.427-.071.459-.39a3.922,3.922,0,0,1,1.019-2.29A4.314,4.314,0,0,1,11.17,0M22.214,22.3q0-5.842.006-11.684c0-.343-.1-.46-.451-.458q-2.731.021-5.461,0c-.349,0-.455.115-.455.457a17.271,17.271,0,0,1-.053,2.333,3.959,3.959,0,0,1-7.813.143A15.006,15.006,0,0,1,7.92,10.62c0-.341-.1-.462-.453-.458-1.629.015-3.258.006-4.887.007-.434,0-.459.026-.459.478q0,7.909,0,15.818c0,.459.022.478.5.478q2.893,0,5.785,0a1.064,1.064,0,0,1,1.213,1.211q0,2.894,0,5.788c0,.483.019.5.51.5q5.785,0,11.57,0c.5,0,.517-.018.517-.533q0-5.806,0-11.612m4.618-3.855q0-5.95,0-11.9c0-.464-.025-.488-.488-.489q-1.8,0-3.593,0c-2.144,0-4.288.006-6.432-.005-.336,0-.487.094-.463.449.023.334,0,.671,0,1.006,0,.531.013.545.544.545q3.162,0,6.324,0a5.039,5.039,0,0,1,.68.042,1.006,1.006,0,0,1,.885.821,2.84,2.84,0,0,1,.044.68q0,10.21,0,20.42c0,.132.006.264,0,.4-.01.244.1.345.345.342.527-.008,1.054,0,1.581,0,.567,0,.569,0,.569-.586q0-5.86,0-11.72M10.261,6.06c-1.042,0-2.084.006-3.125,0-.292,0-.414.1-.4.4.017.395.018.791,0,1.186-.015.317.12.424.424.419.742-.011,1.485,0,2.227,0,1.305,0,2.61-.007,3.915,0,.324,0,.456-.112.439-.442a11.306,11.306,0,0,1,0-1.15c.016-.32-.12-.416-.424-.412-1.018.012-2.036,0-3.053,0m1.64,4.108c-.5,0-1,.008-1.506,0-.264-.006-.363.1-.36.363.009.634-.005,1.268.006,1.9a1.844,1.844,0,0,0,3.686.029c.022-.645,0-1.292.01-1.937,0-.266-.108-.361-.366-.356-.49.011-.98,0-1.47,0M7.481,32.763c.049-.058.013-.183.014-.3q0-1.453,0-2.906c0-.467-.027-.494-.483-.5q-1.47,0-2.94,0c-.11,0-.24-.046-.284.01l3.692,3.687M11.89,3.932c.5,0,1,0,1.5,0,.267,0,.365-.093.306-.371a1.86,1.86,0,0,0-3.631-.032c-.059.274.017.409.317.4.5-.009,1,0,1.5,0",
    transform: "translate(7.15 3.312)",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1491",
    "data-name": "Grupo 1491",
    transform: "translate(-657.389 -546.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_944_-_Contorno",
    "data-name": "Rect\\xE1ngulo 944 - Contorno",
    d: "M0,0H16V1.307H0Z",
    transform: "translate(669 573.614)",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_944_-_Contorno-2",
    "data-name": "Rect\\xE1ngulo 944 - Contorno",
    d: "M0,0H16V1.307H0Z",
    transform: "translate(669 570.307)",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_944_-_Contorno-3",
    "data-name": "Rect\\xE1ngulo 944 - Contorno",
    d: "M0,0H16V1.307H0Z",
    transform: "translate(669 567)",
    fill: "#B7B7B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachedFilesDisabled);
export default __webpack_public_path__ + "static/media/icon_attached_files_disabled.e512c55c2c549da4d6449263d05b4bc8.svg";
export { ForwardRef as ReactComponent };